// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EaZh","carousel":"styles_carousel__3feDi"};